module.exports = __webpack_public_path__ + "assets/img/889225452a0f422281dcc03e0c453b17.png";